/*globals Swiper*/
import {node_observable_component} from 'common/util/ComponentDecorator';

@node_observable_component
export default class JsSliderTags {
    static classname = 'js-slider-tags';

    constructor($wrapper) {
        this.$wrapper = $wrapper;
        this.swiper = null;
        this.init();

        if (!!this.$wrapper.data('desktop-disabled')) {
            this.resize();
        }

    }

    init() {
        const $sliderWrapper = this.$wrapper;
        const desktopDisabled = !!$sliderWrapper.attr('data-desktop-disabled');
        const spaceBetweenDesktop = $sliderWrapper.attr('data-js-spacebetween');
        const spaceBetweenMobile = $sliderWrapper.attr('data-js-spacebetween-mobile');

        if ($(window).width() > 900 && desktopDisabled) {

            if (this.swiper !== null) {
                $sliderWrapper.find('.swiper-button-next, .swiper-button-prev').addClass('swiper-button-disabled');
                this.swiper.destroy();
                this.swiper = null;
            }

        } else if (this.swiper === null) {
            this.swiper = new Swiper($sliderWrapper.find('.swiper-container'), {
                observer: true,
                observeParents: true,
                slidesPerView: 'auto',
                spaceBetween: 10,
                mousewheel: {
                    forceToAxis: true
                },
                navigation: {
                    nextEl: $sliderWrapper.find('.swiper-button-next'),
                    prevEl: $sliderWrapper.find('.swiper-button-prev')
                },
                pagination: {
                    el: null,
                    clickable: true,
                    dynamicBullets: true,
                    dynamicMainBullets: 15,
                },
                scrollbar: {
                    el: null,
                    draggable: true,
                },
                on: {
                    init: function () {
                        $sliderWrapper.find('.swiper-wrapper').toggleClass('swiper-wrapper_before');
                    },
                },
                breakpoints: {
                    900: {
                        spaceBetween: spaceBetweenMobile ? spaceBetweenMobile : 10
                    },
                    1920: {
                        spaceBetween: spaceBetweenDesktop ? spaceBetweenDesktop : 10
                    }
                }
            });

            $sliderWrapper.on('mousedown', '.swiper-button-next, .swiper-button-prev', function (e) {
                e.preventDefault();
            });
        }
    }

    resize() {
        $(window).on('resize', this.init.bind(this));
    }
}
